import React, { useState, useEffect } from "react";
import { InputGroup, Modal, Form, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { endpoint } from "../../utils/api";


//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faFileImport } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faFileImport)

const GenerateTemplateModal = ({ openNewModal, setOpenNewModal, chosenDepartment }) => {
  const [showpopover, setShowPopover] = useState(false)
  const [loading, setLoading] = useState(false);

  const generateTemplate = async () => {

        return Word.run(async (context) => {
 
          await axios({
            method: "post",
            url: `${endpoint}/templates/generate`, 
            data: {
                ids: ids.value,
            } ,
            headers: {
                Authorization: 'Bearer '+ localStorage.token,
                DepartmentName: chosenDepartment
            }
            })
            .then(function async(response) {
                console.log(response.data)
                response.data.map((section) => {
                        if(section[0].file !== null) {
                            let text = Buffer.from(section[0].file, 'hex').toString('utf8');
                            context.document.body.insertOoxml(text, "End")
                        }
          
                    }) 
                    context.sync();  
                    setLoading(false);
                    setOpenFeeModal(false); 
            })
            .catch((error) => {
                console.log(error)
            }) 
        }
            // response.json().then(function (data) {
            //   let text = Buffer.from(data.file, "hex").toString("utf8");
            //   context.document.getSelection().insertOoxml(text, "End");      
            //   context.sync();
            );
    }


  return (
    <Modal backdropClassName="backdrop" show={openNewModal} onHide={() => setOpenNewModal(false)}>
      {showpopover && <SectionPopover className="popover" /> }
      <Modal.Header className="modal-header">
        <Modal.Title >
          Generate Template          
        </Modal.Title>
      </Modal.Header>

        <Modal.Body>
          <Form.Label className="bolder">IDs</Form.Label>
          <InputGroup className="mb-2">
            <Form.Control as="textarea" placeholder="Paste IDs..." id="ids" />
            <Form.Control.Feedback type="invalid">Please paste ids</Form.Control.Feedback>
          </InputGroup>

         </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setOpenNewModal(false)}>
            Close
          </Button>
          <Button className="primary-button border-button" style={{width: loading && '91px'}} onClick={() => {generateTemplate(); setLoading(true)}} disabled={loading}>
          {!loading ?  
                 "Generate"
          :
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    variant="light"
                />          
            }
            </Button>  
        </Modal.Footer>        
    </Modal>
    );
};

export default GenerateTemplateModal;